/* Ott-common */
import { AuthType } from '@dtvgo/axios-interceptor-auth';

export default function users(backendAxiosInstance) {
  /**
   * @typedef CapabilitiesParam
   * @type {object}
   * @property {string} widevineSecurityLevel
   */
  /**
   * @typedef EntitlementTokenParams
   * @type {object}
   * @property {string} tokenType
   * @property {string} assetID
   * @property {string} playbackUrl
   * @property {string} deviceID
   * @property {CapabilitiesParam} capabilities
   */
  /**
   * @param {string} userID
   * @param {EntitlementTokenParams} entitlementTokenParams
   */
  function getEntitlementToken(userID, entitlementTokenParams) {
    return backendAxiosInstance.post(`/entitlements/v1/token/${userID}`,
      entitlementTokenParams,
      {
        authType: AuthType.SESSION_TOKEN,
      });
  }

  return {
    getEntitlementToken,
  };
}
